<div class="date-range-picker-wrapper relative" [class]="styleClass">
  <div 
    #triggerElement
    class="date-range-trigger w-full min-w-[280px] border rounded-lg bg-white cursor-pointer transition-all duration-200"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (click)="toggleDropdown($event)"
  >
    <div class="flex items-center justify-between px-4 py-2">
      <svg 
        class="w-5 h-5 text-gray-400 flex-shrink-0 mr-3"
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
      </svg>
      <span
        class="date-range-picker__value text-sm font-normal flex-1 min-w-0"
        [class.text-gray-400]="!displayValue"
        [class.text-gray-900]="displayValue"
        [attr.title]="displayValue || null"
      >
        <ng-container *ngIf="dateRange?.startDate && dateRange?.endDate; else singleOrPlaceholder">
          <span class="date-range-picker__range-text">
            {{ formatDate(dateRange.startDate) }}<span class="date-range-picker-to"> to </span>{{ formatDate(dateRange.endDate) }}
          </span>
        </ng-container>
        <ng-template #singleOrPlaceholder>
          {{ displayValue || placeholder }}
        </ng-template>
      </span>
      
      <div class="flex items-center gap-2 flex-shrink-0 ml-2">
        <!-- Close icon - show when date range is selected -->
        <svg
          *ngIf="dateRange && (dateRange.startDate || dateRange.endDate) && !disabled"
          class="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          (click)="onClearClick($event)"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Calendar Dropdown -->
  <div
    #calendarDropdown
    *ngIf="isOpen"
    class="date-range-picker-calendar-panel absolute w-full mt-2 bg-white border border-gray-200 rounded-2xl shadow-lg p-4"
    style="top: 100%; left: 0; min-width: 320px; max-width: 340px;"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
  >
    <!-- Calendar Header -->
    <div class="date-range-picker-calendar-header flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900">{{ getMonthName(currentMonth) }}</h3>
      
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          class="date-range-picker-nav-btn w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg hover:bg-green-200 transition-colors border-0 outline-none"
          [class.opacity-50]="!canNavigateToPreviousMonth()"
          [class.cursor-not-allowed]="!canNavigateToPreviousMonth()"
          [disabled]="!canNavigateToPreviousMonth()"
          (mousedown)="$event.stopPropagation()"
          (click)="previousMonth($event)"
          aria-label="Previous month"
        >
          <svg class="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        
        <button
          type="button"
          class="date-range-picker-nav-btn w-8 h-8 flex items-center justify-center bg-green-100 rounded-lg hover:bg-green-200 transition-colors border-0 outline-none"
          [class.opacity-50]="!canNavigateToNextMonth()"
          [class.cursor-not-allowed]="!canNavigateToNextMonth()"
          [disabled]="!canNavigateToNextMonth()"
          (mousedown)="$event.stopPropagation()"
          (click)="nextMonth($event)"
          aria-label="Next month"
        >
          <svg class="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Week Days Header -->
    <div class="grid grid-cols-7 gap-0 mb-2">
      <div
        *ngFor="let day of getWeekDays()"
        class="text-xs font-medium text-gray-500 text-center py-1.5"
      >
        {{ day }}
      </div>
    </div>

    <!-- Calendar Days -->
    <div class="grid grid-cols-7 gap-0">
      <button
        *ngFor="let date of getDaysInMonth(currentMonth); trackBy: trackByDate"
        type="button"
        [class]="getDateClasses(date)"
        [disabled]="isDateDisabled(date)"
        (click)="selectDate(date, $event)"
        (mouseenter)="onDateHover(date)"
        (mouseleave)="onDateLeave()"
      >
        {{ date.getDate() }}
      </button>
    </div>
  </div>
</div>